import { Link } from "react-router-dom";
import "./Product.css";
function Product (props){
    const {Product ,showButton}=props;

    return(
        <div class="card">
            <div className="img">
                <img src={Product.image} class="card-img-top" alt={props.Product.title} />
            </div>
            <div class="card-body">
                <h5 class="card-title">{Product.title}</h5>
                <div className="p">
                    <p class="card-text">{Product.description}</p>
                </div>
                <h6>Price: {Product.price }$</h6>
                <div className="btn">
                    <div>{showButton && <Link class="btn btn-dark b-0" to={`/Product/${Product.id}`}>Details</Link>}</div>
                    <div><Link class="btn btn-dark mr-10 b-0" to={`/Product/${Product.id}`}>Add to card</Link></div>
                </div>
            </div>
       </div>        
    )
}
export default Product; 